import { useEntitlements } from "src/hooks/use-entitlement";

/**
 * Whether predictive traits are enabled for the workspace. The backend
 * entitlement ORs the org-level billing entitlement (provisioned by revops
 * via the CS Admin app) with the `predictive-traits` LaunchDarkly flag, so
 * this replaces direct flag checks.
 */
export const useIsPredictiveTraitsEnabled = (): boolean => {
  const { data } = useEntitlements(true);
  return data.entitlements.predictiveTraits;
};
